import { el } from './dom';

let stack: HTMLElement | null = null;

/** Powiadomienie „Osiągnięcie zdobyte” — wspólne dla obozu i wyprawy, kilka naraz układa się w stos. */
export function achievementToast(name: string, label = 'Osiągnięcie zdobyte'): void {
  if (!stack) {
    stack = el('div', 'achievement-toasts');
    document.getElementById('ui')!.append(stack);
  }
  const toast = el('div', 'achievement-toast frame');
  const text = el('div');
  text.append(el('div', 'ach-toast-label', label), el('div', 'ach-toast-name', name));
  toast.append(el('div', 'ach-toast-icon', '★'), text);
  stack.append(toast);
  requestAnimationFrame(() => toast.classList.add('on'));
  setTimeout(() => toast.classList.remove('on'), 3600);
  setTimeout(() => toast.remove(), 4200);
}
